window.addEventListener("load", () => {
  const COMPONENT_SELECTOR = ".carousel__wrapper";
  const CONTROLS_SELECTOR = ".carousel__controls";
  const CONTENT_SELECTOR = ".carousel__content";

  const components = document.querySelectorAll(COMPONENT_SELECTOR);

  for (let i = 0; i < components.length; i++) {
    const component = components[i];
    const content = component.querySelector(CONTENT_SELECTOR);
    let x = 0;
    let mx = 0;
    const maxScrollWidth =
      content.scrollWidth - content.clientWidth / 2 - content.clientWidth / 2;
    const nextButton = component.querySelector(".arrow-next span");
    const prevButton = component.querySelector(".arrow-prev span");

    if (maxScrollWidth !== 0) {
      component.classList.add("has-arrows");
    }

    if (nextButton) {
      nextButton.addEventListener("click", function (event) {
        event.preventDefault();
        x = content.clientWidth / 2 + content.scrollLeft + 0;
        content.scroll({
          left: x,
          behavior: "smooth",
        });
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", function (event) {
        event.preventDefault();
        x = content.clientWidth / 2 - content.scrollLeft + 0;
        content.scroll({
          left: -x,
          behavior: "smooth",
        });
      });
    }

    const mousemoveHandler = (e) => {
      const mx2 = e.pageX - content.offsetLeft;
      if (mx) {
        content.scrollLeft = content.sx + mx - mx2;
      }
    };

    const mousedownHandler = (e) => {
      content.sx = content.scrollLeft;
      mx = e.pageX - content.offsetLeft;
      content.classList.add("dragging");
    };

    const scrollHandler = () => {
      toggleArrows();
    };

    const toggleArrows = () => {
      const nextButtonNoSpan = component.querySelector(".arrow-next");
      const prevButtonNoSpan = component.querySelector(".arrow-prev");
      let carrouselWrapper = document.querySelector('.carousel__wrapper');

      if (content.scrollLeft > maxScrollWidth - 10) {
        nextButtonNoSpan.classList.add("disabled");
        carrouselWrapper.classList.add("carousel__wrapper--end");
        //carrouselWrapper.classList.remove("carousel__wrapper");
      } else if (content.scrollLeft < 10) {
        prevButtonNoSpan.classList.add("disabled");
        carrouselWrapper.classList.remove("carousel__wrapper--end");
        //prevButtonNoSpan.classList.add("carousel__wrapper");
      } else {
        nextButtonNoSpan.classList.remove("disabled");
        prevButtonNoSpan.classList.remove("disabled");
        carrouselWrapper.classList.remove("carousel__wrapper--end");
        //prevButtonNoSpan.classList.add("carousel__wrapper");
      }
    };

    const mouseupHandler = () => {
      mx = 0;
      content.classList.remove("dragging");
    };

    content.addEventListener("mousemove", mousemoveHandler);
    content.addEventListener("mousedown", mousedownHandler);
    if (component.querySelector(CONTROLS_SELECTOR) !== undefined) {
      content.addEventListener("scroll", scrollHandler);
    }
    content.addEventListener("mouseup", mouseupHandler);
    content.addEventListener("mouseleave", mouseupHandler);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let scrollContainer = document.getElementsByClassName("carousel__content");
  let carouselItem = document.getElementsByClassName("carousel__item");
  let scrollDepth = scrollContainer[0].scrollWidth - innerWidth;
  let activeNextDot = scrollDepth / (carouselItem.length - 1);

  if (carouselItem.length >= 1) {
    if (carouselItem.length <= 3 && innerWidth > 600) {
      let arrowRight = document.getElementById("right");
      arrowRight.style.display = "none";
      scrollContainer[0].style.display = "flex";
      scrollContainer[0].style.justifyContent = "center";
      scrollContainer[0].style.marginLeft = "0";
      for (let i = 0; i < carouselItem.length; i++) {
        carouselItem[i].style.transform = "none";
      }
    }
    scrollContainer[0].addEventListener("scroll", (e) => {
      let carouselContainer = document.getElementsByClassName("carousel");
      if (e.target.scrollLeft > 0) {
        carouselContainer[0].style.transition = "padding-left 0.2s linear";
        carouselContainer[0].style.paddingLeft = "0px";
        carouselContainer[0].classList.add("carousel--scrolling");
      } else {
        carouselContainer[0].style.transition = "padding-left 0.2s linear";
        carouselContainer[0].style.paddingLeft = "24px";
        carouselContainer[0].classList.remove("carousel--scrolling");
      }
    });
  }

  if (innerWidth < 600) {
    let dotContainer = document.getElementById("dot-container-pdp");

    if(!dotContainer){
      return
    }

    for (let i = 0; i < carouselItem.length; i++) {
      let dot = document.createElement("div");
      dot.classList.add("dot");
      dotContainer.appendChild(dot);
    }

    let currentIndex = 0;
    dotContainer.children[currentIndex].classList.add("active");

    scrollContainer[0].addEventListener("scroll", (e) => {
      let currentIndex = Math.round(e.target.scrollLeft / (activeNextDot - 10));
      dotContainer.children[currentIndex].classList.add("active");
      if (currentIndex > 0) {
        dotContainer.children[currentIndex - 1].classList.remove("active");
      }
      dotContainer.children[currentIndex + 1].classList.remove("active");
    });
  }
});
